var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkButton, UitkButtonSize } from 'uitk-react-button';
import { ClickTracker } from 'bernie-analytics';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
var ButtonTracked = ClickTracker(UitkButton);
// eslint-disable-next-line react/prefer-stateless-function
var HeaderSecondaryNavigationElementLink = /** @class */ (function (_super) {
    __extends(HeaderSecondaryNavigationElementLink, _super);
    function HeaderSecondaryNavigationElementLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderSecondaryNavigationElementLink.prototype.render = function () {
        var secondaryElementData = this.props.secondaryElementData;
        var _a = this.props, showText = _a.showText, showIcon = _a.showIcon;
        showText = showText !== undefined ? showText : false;
        showIcon = showIcon !== undefined ? showIcon : false;
        var id = secondaryElementData.id, iconName = secondaryElementData.iconName, text = secondaryElementData.text, trackingEvent = secondaryElementData.trackingEvent, url = secondaryElementData.url, newWindow = secondaryElementData.newWindow;
        var snlId = "".concat(id, "-button");
        var snlIconClass = "".concat(id, "__icon");
        var ariaLabel = newWindow ? "".concat(text, ". Opens in a new window.") : text;
        if ((!showText || !text) && (!showIcon || !iconName)) {
            return null;
        }
        var buttonSize = showText && text ? UitkButtonSize.MEDIUM : UitkButtonSize.LARGE;
        var getChildren = function () {
            var children = [];
            if (showIcon && iconName) {
                children.push(React.createElement(UitkIcon, { name: iconName, size: UitkIconSize.MEDIUM, key: "icon-".concat(id) }));
            }
            if (showText && text) {
                children.push(React.createElement(UitkText, { size: 300, key: "text-".concat(id) }, text));
            }
            return children;
        };
        var element = (React.createElement.apply(React, __spreadArray([ButtonTracked, { size: buttonSize, id: id, rfrr: trackingEvent, href: url, linkName: id, "aria-label": ariaLabel, "data-stid": snlId, trackImmediate: true, target: newWindow ? '_blank' : '_self' }], __read(getChildren()), false)));
        if (showText && text) {
            return React.createElement("div", { className: snlIconClass, key: "div-".concat(id) }, element);
        }
        return React.createElement("div", { className: snlIconClass, key: "div-".concat(id) },
            React.createElement(UitkSpacing, { padding: { inline: 'three' } }, element));
    };
    return HeaderSecondaryNavigationElementLink;
}(React.Component));
export { HeaderSecondaryNavigationElementLink };
//# sourceMappingURL=header-secondary-navigation-element-link.js.map